import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { PlanNoticeService } from '../services/plan-notice.service';

/**
 * Any request refused because of the school's plan raises the "upgrade your
 * plan" popup, wherever in the app it came from — a single admission, an
 * import, a branch, a staff login. The error is passed on unchanged, so the
 * screen that asked still shows its own message.
 */
export const planNoticeInterceptor: HttpInterceptorFn = (req, next) => {
  const notices = inject(PlanNoticeService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && (error.status === 403 || error.status === 409)) {
        notices.offer(error.error?.detail);
      }
      return throwError(() => error);
    })
  );
};
